const projectsFilter = () => {
    const filterParent = document.querySelector('.main--projects');
    if (!filterParent) return;

    const filterItems = document.querySelectorAll('.js-filter');
    if (!filterItems.length) return;

    // Встановлюємо перший фільтр активним за замовчуванням
    filterItems[0].classList.add('item--active');

    const filterCards = (filterValue) => {
        // Перезавантажуємо селектори на випадок, якщо картки додалися динамічно
        const worksCards = document.querySelectorAll('.works__card');
        const projectCards = document.querySelectorAll('.card-project');

        // Фільтруємо картки в секції works
        worksCards.forEach((card) => {
            if (filterValue === 'all') {
                card.style.display = '';
            } else {
                // Перевіряємо, чи картка має відповідний клас типу об'єкта
                const hasOwnClass = card.classList.contains('works--own');
                const hasSubcontractorClass = card.classList.contains('works--subcontractor');
                const hasGeneralContractorClass = card.classList.contains('works--general-contractor');
                
                let shouldShow = false;
                
                if (filterValue === 'own' && hasOwnClass) {
                    shouldShow = true;
                } else if (filterValue === 'subcontractor' && hasSubcontractorClass) {
                    shouldShow = true;
                } else if (filterValue === 'general-contractor' && hasGeneralContractorClass) {
                    shouldShow = true;
                }
                
                card.style.display = shouldShow ? '' : 'none';
            }
        });

        // Фільтруємо картки в секції other
        projectCards.forEach((card) => {
            if (filterValue === 'all') {
                card.style.display = '';
            } else {
                // Перевіряємо, чи картка має відповідний клас типу об'єкта
                const hasOwnClass = card.classList.contains('card--own');
                const hasSubcontractorClass = card.classList.contains('card--subcontractor');
                const hasGeneralContractorClass = card.classList.contains('card--general-contractor');
                
                let shouldShow = false;
                
                if (filterValue === 'own' && hasOwnClass) {
                    shouldShow = true;
                } else if (filterValue === 'subcontractor' && hasSubcontractorClass) {
                    shouldShow = true;
                } else if (filterValue === 'general-contractor' && hasGeneralContractorClass) {
                    shouldShow = true;
                }
                
                card.style.display = shouldShow ? '' : 'none';
            }
        });
    };

    filterItems.forEach((filter) => {
        filter.addEventListener('click', () => {
            const filterValue = filter.dataset.filter;

            // Міняємо активний клас на кнопках фільтра
            filterItems.forEach((item) => {
                item.classList.remove('item--active');
            });
            filter.classList.add('item--active');

            // Викликаємо функцію фільтрації
            filterCards(filterValue);
        });
    });
};

export default projectsFilter;
